import React from "react";

import PieChart, {
  Legend,
  Series,
  Tooltip,
  Format,
  Label,
} from "devextreme-react/pie-chart";

export default function PieChartComponent({ datasource = [] }) {
  function customizeTooltip(arg) {
    return {
      text: `${(arg.percent * 100).toFixed(2)}%`,
    };
  }
  return (
    <PieChart
      id="pie"
      className="pie"
      type="doughnut"
      palette="Soft Pastel"
      dataSource={datasource}
    >
      <Series argumentField="typeName" valueField="totalHours">
        <Label visible={true} format="percent" />
      </Series>
      <Legend margin={0} horizontalAlignment="right" verticalAlignment="top" />
      <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
        <Format type="millions" />
      </Tooltip>
    </PieChart>
  );
}
